(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.site-header');

  if (!header) return;

  function isMobile() {
    return window.innerWidth < 750;
  }

  header.style.top = '0';

  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', function () {
    if (isMobile()) {
      header.style.top = '0'; // Always stick to top, overlaying the announcement
    }
    lastScrollY = window.scrollY;
  });
});

  } catch(e) { console.error(e); }
})();
})();
